var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('default-template', {
    scopedSlots: _vm._u([{
      key: "fab",
      fn: function fn(_ref) {
        var showScroll = _ref.showScroll,
            scrollTo = _ref.scrollTo;
        return [_vm._t("fab", null, {
          "showScroll": showScroll,
          "scrollTo": scrollTo
        })];
      }
    }], null, true)
  }, [_c('v-container', [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }